module.exports = __webpack_public_path__ + "img/compact.5465f9c5.png";